import Api from '../api'

export default {

    get: async () => {

        return Api.agreements.get()
    },

    set: {

        terms: async () => {

            return Api.agreements.update('terms')

        },

        privacy: async () => {

            return Api.agreements.update('privacy')
        }
    }
}
